<div class="modal-wrapper">
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
      i18n="@@survey.inside.dialog.unsaved.title"
    >
      You haven't saved your changes
    </h4>
    <i class="fas fa-times" (click)="activeModal.dismiss('Cross click')"></i>
  </div>
  <div class="modal-body">
    <p i18n="@@survey.inside.dialog.unsaved.text">
      Your unsaved changes will be lost. Save changes before exiting building
      layout editor
    </p>
  </div>
  <div class="modal-footer">
    <button
      class="quit-button"
      (click)="onNo()"
      i18n="@@survey.inside.dialog.unsaved.button.cancel"
    >
      Quit without saving
    </button>
    <button *ngIf="isValid" class="save-button" (click)="onYes()">
      <img src="assets/Keen&Wise_save_transparant.png" />
      <span i18n="@@survey.inside.dialog.unsaved.button.save">Save</span>
    </button>
    <button *ngIf="!isValid" class="back-button" (click)="onBack()">
      <span i18n="@@survey.inside.dialog.unsaved.button.resume"
        >Resume editing</span
      >
    </button>
  </div>
</div>
